// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_ISO_IMAGE_LIST = 'isoImage/SET_ISO_IMAGE_LIST';
export const ADD_ISO_IMAGE_ITEM = 'isoImage/ADD_ISO_IMAGE_ITEM';
export const SET_ISO_IMAGE_ITEM = 'isoImage/SET_ISO_IMAGE_ITEM';
export const UNSET_ISO_IMAGE_ITEM = 'isoImage/UNSET_ISO_IMAGE_ITEM';
export const REMOVE_ISO_IMAGE_ITEM = 'isoImage/REMOVE_ISO_IMAGE_ITEM';
export const UPDATE_ISO_IMAGE_ITEM = 'isoImage/UPDATE_ISO_IMAGE_ITEM';
export const SET_ISO_IMAGE_ITEM_IS_DELETING = 'isoImage/SET_ISO_IMAGE_ITEM_IS_DELETING';
